import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'fgb-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit {
  showAppleLink = true;
  showGoogleLink = true;
  screenType = ScreenType;

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    public deviceDetector: DeviceDetectorService
  ) {
    if (this.authService.checkMaintenceMode()) {
      if (this.authService.hasCurrentRefreshToken()) {
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['login']);
      }
    }
  }

  ngOnInit() {
    this.downloadAppLink();
  }

  downloadAppLink() {
    if (this.deviceDetector.os.match('iOS')) {
      this.showGoogleLink = false;
    } else if (this.deviceDetector.os.match('Android')) {
      this.showAppleLink = false;
    }
  }
}
